import { clsx } from 'clsx'
import css from 'component/Button/CircleButton.module.scss'
import { useLatestCallback } from 'hook/useLatestCallback'
import { ClickAction, useOnClickAction } from 'hook/useOnClickAction'
import { CSSProperties, ReactNode } from 'react'
import { styles } from 'util/style'

type Props = {
  action?: ClickAction | false
  children?: ReactNode
  className?: string
  disabled?: boolean
  large?: boolean
  style?: CSSProperties
  size?: number
}

export function CircleButton(props: Props) {
  const { children, disabled, large, size } = props
  const { busy, onClick } = useOnClickAction(props)
  const className = clsx(props.className, css.button, disabled && css.disabled,
    large && css.large, busy && css.busy)
  const style = styles({ width: size, height: size, ...props.style })

  const onMouseDown = useLatestCallback((event: any) => {
    event.stopPropagation()
  })

  return <div role="button" className={className} style={style} onClick={onClick} onMouseDownCapture={onMouseDown}>
    {children}
  </div>
}
